import { render, staticRenderFns } from "./Arbitration.vue?vue&type=template&id=63a39e36&scoped=true&"
import script from "./Arbitration.vue?vue&type=script&lang=js&"
export * from "./Arbitration.vue?vue&type=script&lang=js&"
import style0 from "./Arbitration.vue?vue&type=style&index=0&id=63a39e36&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a39e36",
  null
  
)

export default component.exports